import * as React from "react";
import { Box, Button, TextField, Typography } from "../../../components/mui";
import Modal from "../../../components/shared/Modal";
import { useToast } from "../../../components/shared/ToastProvider";

import "../../../styles/main.css";
import "../../../styles/pages/condoUnitDetail.css";

// UI-only form for creating/updating a single security expense row.
export default function SecurityExpenseFormModal({
  open,
  onClose,
  mode = "add", // "add" | "edit"
  initialValues = {}
}) {
  const isEdit = mode === "edit";
  const { showToast } = useToast();

  const handlePrimaryClick = () => {
    if (showToast) {
      showToast({
        message: isEdit ? "Expense updated" : "Expense created",
        severity: "success"
      });
    }
    if (onClose) onClose();
  };

  const actions = (
    <>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="contained" onClick={handlePrimaryClick}>
        {isEdit ? "Update" : "Create"}
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={isEdit ? "Edit Expense" : "Add Expense"}
      actions={actions}
      maxWidth="xs"
      fullWidth
    >
      <Box className="modal-form-grid modal-form-grid--spaced">
        <TextField
          fullWidth
          required
          size="small"
          className="modal-form-row"
          label="Item"
          defaultValue={initialValues.item || ""}
        />

        <TextField
          fullWidth
          required
          size="small"
          className="modal-form-row"
          label="Currency"
          defaultValue={initialValues.currency || "PHP"}
        />

        <TextField
          fullWidth
          required
          size="small"
          className="modal-form-row"
          type="number"
          label="Amount"
          defaultValue={initialValues.amountValue || "0"}
        />
      </Box>
    </Modal>
  );
}
